import { gql } from '@apollo/client';
import { graphql } from '@xolv-mybrightlink/common';
import { NotificationData, NotificationType } from './model/NotificationData';

const FETCH_NOTIFICATION_QUERY = gql`
  query invisibleNotifications($notificationType: String) {
    invisibleNotifications(notificationType: $notificationType) {
      newConnection {
        guid
        notificationType
        createdDate
        connection {
          userConnectionGuid
          userConnectionStatus
          userProfileGuid
        }
      }
    }
  }
`;

const MARK_NOTIFICATION_AS_READ_MUTATION = gql`
  mutation markNotificationAsRead($guid: String) {
    markNotificationAsRead(guid: $guid)
  }
`;

export const fetchInvisibleNotification = async (
  notificationType: NotificationType,
): Promise<NotificationData> => {
  const response = await graphql.query<{
    invisibleNotifications: NotificationData;
  }>({
    query: FETCH_NOTIFICATION_QUERY,
    variables: {
      notificationType: notificationType,
    },
    fetchPolicy: 'no-cache',
  });
  return response.data.invisibleNotifications;
};

export const markNotificationAsRead = async (guid: string) => {
  await graphql.mutate({
    mutation: MARK_NOTIFICATION_AS_READ_MUTATION,
    variables: {
      guid: guid,
    },
  });
};
